import React from 'react';
import { useHistory } from "react-router-dom";

import './Core.scss';

import { ROUTER_ENDPOINTS } from '../../../router/router-endpoints';
import { useAuth } from '../../../services/auth/auth-context';

import { Button } from '../../../components/basic/Button/Button';
import { ItusLogo } from '../../../components/ItusLogo/ItusLogo';

export function Core() {
  const history = useHistory();
  const auth = useAuth();

  const handleAuthClick = () => {
    history.push(ROUTER_ENDPOINTS.AUTH);
  };

  return (
    <div className='Core'>
      <ItusLogo />
      <div className='Core__text-wrapper'>
        <h3 className='Core__subtitle'>"Mark my words"</h3>
        <p className='Core__about'>
          "ITUS" is a public network that gives you joy from sharing the "I Told You So" post and provides undeniable proof of your past statements to boost your significance among others.
        </p>

        {
          !auth.user
            ? (
              <div className="Core__become-a-member">
               <Button buttonType='neutral' text='Join' handleClick={handleAuthClick} />
              </div>
            )
            : null
        }
        
      </div>
    </div>
  );
}
